import { Component, Inject } from '@angular/core';
import { Constant } from '../../constant';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonUtil } from '../../util/common-util';
import { ToastUtil } from '../../util/toast-util';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../../auth/auth.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

interface OrgNode {
  id: number;
  name: string;
  children?: OrgNode[];
  path?: string;
  checked?: boolean;
  manual?: boolean;
}
@Component({
    selector: 'app-concurrent-edit-dialog',
    templateUrl: './concurrent-edit-dialog.component.html',
    styleUrl: './concurrent-edit-dialog.component.css',
    standalone: false,
})
export class ConcurrentEditDialogComponent {
  public readonly Constant = Constant;
  public form: FormGroup;
  public isSaving = false;
  public maxLenColor = 6
  //public mainColor
  public colorPreviewId = 'main-color-preview'
  private apiPath = '/master';
  public auths;
  public accountAuth;
  public mailaddress;
  public account;
  public showSpinner = true;
  public currentAuth;
  public loginAuthCode: number;
  public treeControl = new NestedTreeControl<OrgNode>(node => node.children);
  public dataSource = new MatTreeNestedDataSource<OrgNode>();
  public selectedNodes: OrgNode[] = [];
  public master4: OrgNode[] = [];

  hasChild = (_: number, node: OrgNode) =>
    !!node.children && node.children.length > 0;
  trackByFn = (_: number, node: OrgNode) => node.id;
  constructor(
    public dialogRef: MatDialogRef<ConcurrentEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private auth: AuthService,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
  ) {



  }

  ngOnInit() {
    this.getDetail();

  }

  onSave() {
    if (!this.commonUtil.checkOnline()) {
      this.isSaving = false;
      return;
    }

    if (this.isSaving) {
      return;
    }

    this.isSaving = true;
    const selected = this.master4.filter(org => org.checked);
    this.dialogRef.close(selected);
  }

  getDisplayLevel(node: OrgNode): number {
    let level = 0;
    let current: OrgNode | null = node;

    while (current) {

        level++;

      current = this.findParent(this.dataSource.data, current);
    }

    return level - 1; // ルートを0にする
  }

  onInput() {
    const mail_address = this.form.value.mail_address;

    if (mail_address.length < 6) {
      return
    }

  }

  onChange() {
    const auth = this.form.value.accountAuth;

    if (auth.length < 6) {
      return
    }

  }

  onCompositionEnd() {
    this.onInput()
  }

  getLevel(node: OrgNode): number {
    let level = 0;
    let parent = this.findParent(this.dataSource.data, node);
    while (parent) {
      level++;
      parent = this.findParent(this.dataSource.data, parent);
    }
    return level;
  }

  private findParent(nodes: OrgNode[], target: OrgNode): OrgNode | null {
    for (const node of nodes) {
      if (node.children?.includes(target)) {
        return node;
      }
      const found = this.findParent(node.children || [], target);
      if (found) return found;
    }
    return null;
  }

    /* プライベート */
  // 詳細取得
  private getDetail() {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
      this.dialogRef.close();
      return;
    }

    Auth.currentSession().then(session => {
      const apiPath = this.apiPath;
      const options = this.auth.createApiHeader(session);
      this.commonUtil.apiGet(apiPath, options).then(res => {
        if (!res.data) {
          // 削除済み
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgDeleteAccountAlreadyError, Constant.toastShowMiliSec);
          this.dialogRef.close(true);
          return;
        }
        const master = res.data.master;
        this.master4 = (master["4"] || []).map(x => ({ ...x, checked: false }));
        if (this.data?.selected) {
          this.master4.forEach(org => {
            org.checked = this.data.selected.some(s => s.id === org.id);
          });
        }
        this.showSpinner = false;
      })
      .catch(err => {
        this.commonUtil.debug().log(err);
        if (err.message === Constant.msgLoginFailed) {
          this.commonUtil.showReloadDialog(this.auth);
        } else {
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
          this.dialogRef.close();
        }
      });
    });
  }

  private normalize(nodes: any[]): OrgNode[] {
    return nodes.map(n => {
      const isSkip = n.name?.includes('#skip');

      return {
        id: n.id,
        name: n.name,
        // skipでも children はそのまま
        children: this.normalize(n.children ?? []),
        // フラグ追加
        skip: isSkip
      };
    });
  }

  private initTree(master) {

    const honbu: OrgNode = {
      id: 1,
      name: '本部',
      children: this.normalize(master['1'] ?? [])
    };

    const shibu: OrgNode = {
      id: 2,
      name: '支部',
      children: this.normalize(master['2'] ?? [])
    };

    const area: OrgNode = {
      id: 3,
      name: 'エリア',
      children: this.normalize(master['3'] ?? [])
    };

    this.dataSource.data = [honbu, shibu, area];
    this.applySelected(this.data?.selected || []);
    this.expandSkipNodes(this.dataSource.data);

  }

  applySelected(selectedList: any[]) {

    const traverse = (nodes: OrgNode[]) => {
      for (const node of nodes) {

        const path = this.getPath(node);

        // path一致でチェック
        if (selectedList.some(s => s.path === path)) {
          node.checked = true;
          node.manual = true;

          // 親もチェック
          this.checkParents(node);
        }

        if (node.children) {
          traverse(node.children);
        }
      }
    };

    traverse(this.dataSource.data);
  }

  private initForm() {
    this.form = new FormGroup({
      mailaddress: new FormControl(this.account.user_id, [Validators.required]),
      accountAuth: new FormControl(
        String(this.account.user_authority),
        Validators.required
      ),
    });
    this.currentAuth = this.form.get('accountAuth')?.value;
    //this.form.get('mailaddress')?.disable({ emitEvent: false });
  }

  expandSkipNodes(nodes: OrgNode[]) {
    for (const node of nodes) {

      if ((node as any).skip) {
        this.treeControl.expand(node); // 👈 強制展開
      }

      if (node.children) {
        this.expandSkipNodes(node.children);
      }
    }
  }

  getPath(node: OrgNode): string {
    const path: string[] = [];

    let current: OrgNode | null = node;

    while (current) {

      if (!(current as any).skip) {
        path.unshift(current.name);
      }

      current = this.findParent(this.dataSource.data, current);
    }

    return path.join(' ');
  }

  toggleNode(node: OrgNode, checked: boolean) {
    node.checked = checked;
    node.manual = checked;

    if (checked) {
      this.checkParents(node);
    } else {
      this.uncheckChildren(node); // 👈 下を全部消す
    }
  }

  uncheckChildren(node: OrgNode) {
    if (!node.children) return;

    for (const child of node.children) {
      child.checked = false;
      child.manual = false; // 👈 今回は消すのが正解

      this.uncheckChildren(child);
    }
  }

  checkParents(node: OrgNode) {
    let parent = this.findParent(this.dataSource.data, node);

    while (parent) {
      parent.checked = true;

      // これを追加（超重要）
      parent.manual = true;

      parent = this.findParent(this.dataSource.data, parent);
    }
  }

  getSelectedNodes(): OrgNode[] {
    const result: OrgNode[] = [];

    const traverse = (nodes: OrgNode[]) => {
      for (const node of nodes) {

        const hasManualChild = node.children?.some(child => child.manual);

        // 自分はmanualで、子にmanualがいない
        if (node.manual && !hasManualChild) {
          result.push(node);
        }

        if (node.children) {
          traverse(node.children);
        }
      }
    };

    traverse(this.dataSource.data);
    return result;
  }

  isParentChecked(node: OrgNode): boolean {
    let parent = this.findParent(this.dataSource.data, node);

    while (parent) {
      if (parent.checked) return true;
      parent = this.findParent(this.dataSource.data, parent);
    }

    return false;
  }

  onCheck(node: OrgNode, checked: boolean) {
    if (checked) {
      this.selectedNodes.push(node);
    } else {
      this.selectedNodes = this.selectedNodes.filter(n => n.id !== node.id);
    }
  }
}
